import { ArtifactGenerator } from './ArtifactGenerator';

export class ResearchPaperGenerator extends ArtifactGenerator {
  generatePrompt(): string {
    return `You are an expert technical researcher and writer.
I will provide a set of ideas below, and I'd like you to create a comprehensive research paper outline.

Context and Ideas:

${this.getIdeaHierarchy()}

Please create a detailed research paper following this structure:

# Title
Create a clear, specific title that accurately reflects the research focus

# Abstract
- Brief overview of the research
- Problem statement
- Methodology
- Key findings
- Implications

# 1. Introduction
## 1.1 Background
- Context of the research
- Significance of the problem
- Current state of the field

## 1.2 Problem Statement
- Clear articulation of the research problem
- Research questions
- Hypotheses

## 1.3 Research Objectives
- Primary objectives
- Secondary objectives
- Expected outcomes

# 2. Literature Review
## 2.1 Theoretical Framework
- Key theories and concepts
- Related work
- Current gaps in knowledge

## 2.2 State of the Art
- Current solutions
- Technological landscape
- Industry trends

# 3. Methodology
## 3.1 Research Design
- Approach and rationale
- Methods used
- Data collection techniques

## 3.2 Technical Implementation
- System architecture
- Technologies used
- Implementation details

## 3.3 Evaluation Methods
- Testing procedures
- Metrics
- Validation approach

# 4. Results
## 4.1 Findings
- Primary results
- Statistical analysis
- Performance metrics

## 4.2 Analysis
- Interpretation of results
- Patterns and trends
- Comparative analysis

# 5. Discussion
## 5.1 Implications
- Theoretical implications
- Practical implications
- Industry impact

## 5.2 Limitations
- Current constraints
- Technical limitations
- Future improvements

# 6. Conclusion
- Summary of findings
- Contributions
- Future work
- Recommendations

# References
- Cite relevant papers
- Industry reports
- Technical documentation

# Appendices
- Technical specifications
- Additional data
- Supplementary materials

Formatting Guidelines:
- Use proper markdown formatting
- Include tables and figures where appropriate
- Use consistent citation style
- Format code snippets properly
- Use clear section numbering

The paper should:
- Be academically rigorous
- Include technical depth
- Be well-structured
- Support claims with evidence
- Follow academic writing conventions
- Be approximately 5000-7000 words

Generate the complete research paper now, using proper markdown formatting and maintaining an academic, professional tone.`;
  }

  protected getIdeaHierarchy(): string {
    return this.ideas.map(idea => {
      let content = idea.content;
      if (idea.children.length > 0) {
        content += '\n\n' + idea.children.map(child => child.content).join('\n\n');
      }
      return content;
    }).join('\n\n');
  }
}
